import React from 'react';
import { Textbox } from "components/Textbox/Textbox";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { trans } from "utils/helpers";

interface BasicSettingsProps {
    object: any;
    defaultValueDateTimeNow: boolean;
}

export const BasicSettings: React.FC<BasicSettingsProps> = ({ object, defaultValueDateTimeNow }) => {
    if (object?.typeName === 'Message' || object?.typeName === 'emptySpace') {
        return null;
    }

    return (
        <>
            <div className="col-12">
                <div>
                    <Textbox
                        textboxType="text"
                        textboxName="label"
                        labelText={trans("label")}
                        required
                        defaultValue={object?.typeName === "emptySpace" ? "emptySpace" : object?.label}
                        readonly={object?.typeName === "emptySpace"}
                    />
                </div>
            </div>
            <div className="col-12">
                <div>
                    <Textbox
                        textboxType="systemKey"
                        textboxName="SystemKey"
                        labelText={trans("field")}
                        required
                        defaultValue={object?.SystemKey}
                        readonly={object?.SystemKey === "Description"|| object?.SystemKey=="activityStatus" || object?.SystemKey === "attachment" ||object?.SystemKey === "RequesterPositionId" || object?.SystemKey === "SystemNumber"}
                    />
                </div>
            </div>
            {object?.typeName !== 'Step' && (
                <>
                   {object?.typeName !== 'button'  &&  <div className="col-6">
                        <div className="d-flex align-items-end w-100 h-100">
                            <CheckableButton
                                type="checkbox"
                                labelText="required"
                                inputName="required"
                                checked={defaultValueDateTimeNow}
                                defaultChecked={object?.required || false}
                                defaultValue={object?.required || false}
                                readOnly={object?.SystemKey === "Description" || object?.SystemKey === "RequesterPositionId"}
                            />
                        </div>
                    </div>}
                    <div className="col-6">
                        <div className="d-flex align-items-end w-100 h-100">
                            <CheckableButton
                                type="checkbox"
                                labelText="disable"
                                inputName="disable"
                                checked={defaultValueDateTimeNow}
                                defaultChecked={object?.disable || false}
                                defaultValue={object?.disable || false}
                                readOnly={object?.SystemKey === "Description" || object?.SystemKey === "RequesterPositionId"}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
}; 